import { Box } from '@betterment/samba-react';

import { LegendItem } from './ProjectionChartLegendItem';

export const BalanceProjectionChartLegend: React.FC = () => {
  return (
    <Box css={{ display: 'flex', flexDirection: 'row', gap: 'space.200', flexWrap: 'wrap' }}>
      <LegendItem>
        <LegendItem.Shape
          css={{
            width: '10px',
            height: '3px',
            backgroundColor: 'dataviz.blue.2',
            borderRadius: '0 token(radii.round) token(radii.round) 0',
          }}
        />
        <LegendItem.Label>Average outcome</LegendItem.Label>
      </LegendItem>
      <LegendItem>
        <LegendItem.Shape
          css={{ width: '6px', height: '6px', backgroundColor: 'dataviz.blue.overlay', borderRadius: '2px' }}
        />
        <LegendItem.Label>Outcome range</LegendItem.Label>
      </LegendItem>
      <LegendItem>
        <LegendItem.Shape
          css={{
            width: '10px',
            height: '1px',
            backgroundColor: 'border.strong',
            borderRadius: 'round',
          }}
        />
        <LegendItem.Label>Net deposits</LegendItem.Label>
      </LegendItem>
    </Box>
  );
};
